export const CONTACT = {
  email: "info@kodpilot.com",
  phoneDisplay: "0(850) 307 3637",
  phoneHref: "tel:+908503073637",
  address: "Odunluk Mah. Odunluk Cad. No:13/C, Nilüfer/BURSA",
  maps: "https://goo.gl/maps/bpStyZVggfvBRsdh6",
  whatsappNumber: "908503073637",
  instagram: "https://www.instagram.com/kodpilot/",
  youtube: "https://www.youtube.com/@kodpilottv9418",
};

export const STATS = [5, 50, 45];

export const REFERENCES = [
  { id: "trafixa", href: "https://trafixa.com", host: "trafixa.com", tone: "r1", wide: true, symbol: "AI" },
  { id: "coforob", href: "https://coforob.com", host: "coforob.com", tone: "r2", wide: true, symbol: "☕" },
  { id: "fink", href: "https://fink.games", host: "fink.games", tone: "r3", wide: true, symbol: "▲" },
  { id: "eksenix", href: "https://eksenix.com", host: "eksenix.com", tone: "r4", wide: true, symbol: "⚙" },
  { id: "capuchin", href: "https://capuchin.com.tr", host: "capuchin.com.tr", tone: "r5", wide: true, symbol: "◉" },
  { id: "sailpage", href: "https://sailpage.com", host: "sailpage.com", tone: "r6", wide: true, symbol: "⛵" },
];

export const LANGS = [
  { code: "tr", label: "TR", name: "Türkçe" },
  { code: "en", label: "EN", name: "English" },
  { code: "de", label: "DE", name: "Deutsch" },
  { code: "ru", label: "RU", name: "Русский" },
  { code: "zh", label: "ZH", name: "中文" },
];
